import { Injectable } from '@angular/core';
import { Socket } from 'socket.io-client';
import { CreditType } from '../enums/credit-type.enum';
import { setCredits } from '../store/credits/credits.actions';
import { BaseCompanySocketClass } from './base-company-socket.class';

@Injectable({
  providedIn: 'root',
})
export class CreditsSocketService extends BaseCompanySocketClass {

  connect(): void {
    this.connectWithAuth();
  }

  protected override getNamespace(): string {
    return 'socket/credits';
  }

  protected override registerListeners(socket: Socket): void {
    socket.on(
      'credits.updated',
      (data: {
        [key in CreditType]: {
          total: number;
          left: number;
          reserved: number;
        };
      }) => {
        this.store.dispatch(setCredits({ count: data }));
      }
    );
  }
}
